import { render } from "./ASGroupForm.vue?vue&type=template&id=6c610d30&scoped=true"
import script from "./ASGroupForm.vue?vue&type=script&lang=ts"
export * from "./ASGroupForm.vue?vue&type=script&lang=ts"

import "./ASGroupForm.vue?vue&type=style&index=0&id=6c610d30&lang=scss&scoped=true"
import "@vueform/toggle/themes/default.css?vue&type=style&index=1&lang=css"
script.render = render
script.__scopeId = "data-v-6c610d30"

export default script